module.exports = __webpack_public_path__ + "img/smartby_logo_dark.4991a6d4.png";